import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CreateMode from './CreateMode';
import { translate } from '../../locales';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { styled } from '@mui/material/styles';

const AddButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isMultiSelectionMode'
})(({ theme, isMultiSelectionMode }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  marginTop: !isMultiSelectionMode ? theme.spacing(1) : undefined,
  padding: isMultiSelectionMode
    ? theme.spacing(1.25, 1.5, 1.25, 2.75)
    : theme.spacing(1, 1.5, 1, 1.875),
  '&:hover': {
    borderRadius: 'unset'
  },
  '&:focus': {
    borderRadius: 'unset'
  }
}));

const CreateNew = ({
  placeholder = translate('createNew.placeholder'),
  addButtonText = translate('createNew.addItem'),
  AddButtonProps,
  isMultiSelectionMode,
  onChange,
  onClose
}) => {
  const [isCreateMode, setCreateMode] = useState(false);

  if (isCreateMode) {
    return (
      <CreateMode
        isMultiSelectionMode={isMultiSelectionMode}
        placeholder={placeholder}
        onChange={onChange}
        onClose={() => {
          setCreateMode(false);
          onClose();
        }}
      />
    );
  }

  return (
    <div data-qa-id="add-item-container">
      <AddButton
        data-qa-id="add-item-button"
        variant="text"
        color="primary"
        isMultiSelectionMode={isMultiSelectionMode}
        onClick={() => setCreateMode(true)}
        startIcon={<AddOutlinedIcon />}
        children={addButtonText}
        {...AddButtonProps}
      />
    </div>
  );
};

CreateNew.propTypes = {
  placeholder: PropTypes.string,
  addButtonText: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func
};

export default CreateNew;
